import { ImportType } from "@mimber/schema"
import type { ImportWizardConfig } from "@/components/blocks/ImportWizardModal"

const FIELD_DEFINITIONS = [
  { key: "firstName", label: "First name", required: true },
  { key: "lastName", label: "Last name", required: true },
  { key: "email", label: "Email", required: true },
]

export const managedMemberImportConfig: ImportWizardConfig = {
  importType: ImportType.MANAGED_MEMBER_IMPORT,
  title: "Import Managed Members",
  description:
    "Add members directly to your directory. No email is sent — you'll manage their information on their behalf.",
  fieldDefinitions: FIELD_DEFINITIONS,
  templateHeaders: ["First Name", "Last Name", "Email"],
  templateFilename: "managed-members-template.csv",
  successMessage:
    "The imported members are being processed and you will be emailed once it is completed.",
}
